<template>
    <div id="planning_urusan" >

<section class="content">
<div class="container-fluid">

        <div class="row clearfix">

            <div class="bg-light-green" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">
                    <div class="col-md-3 searching">
                        <span class="h_page">IKU Daerah</span> <br> <br>
                    </div>
                    <div class="col-md-6">

                    </div>
                    <div class="col-md-3 searching">
                        <div class="input-group">
                            <span class="input-group-btn">
                                <button type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons">add</i></button>
                            </span>
                            <input type="text" class="form-control" placeholder="Cari data" id="caridata" >
                        </div> <br>
                    </div>
                </div>
            </div>


            <div class="col-xs-12 card">
        <!-- ============================================================ MULAI ======================================================================== -->
                <br>
                <div class="table-responsive">
                    <table class="table table-bordered" style="width: 100%">
                        <thead>
                        <tr class="">
                            <th rowspan="2" class="text-center" style="width: 5%">No.</th>
                            <th rowspan="2" style="width: 30%">Uraian Indikator</th>
                            <th class="text-center" colspan="6" style="width: 30%">Target (THN)</th>
                            <th class="text-center" colspan="6" style="width: 30%">Realisasi (THN)</th>
                            <th style="width: 5%" rowspan="2"></th>
                        </tr>
                        <tr class="">
                            <th class="text-center">2016</th>
                            <th class="text-center">2017</th>
                            <th class="text-center">2018</th>
                            <th class="text-center">2019</th>
                            <th class="text-center">2020</th>
                            <th class="text-center">2021</th>
                            <th class="text-center">2016</th>
                            <th class="text-center">2017</th>
                            <th class="text-center">2018</th>
                            <th class="text-center">2019</th>
                            <th class="text-center">2020</th>
                            <th class="text-center">2021</th>
                        </tr>
                        </thead>
                        <tbody>
                          <!-- track-by="data.createdtime" -->
                          <tr class="h_isitable" v-for="(data, index) in list_data" :key="data.urusan_pemerintahan_id">
                              <td class="text-center">{{index+1}}</td>
                              <td >{{data.uraian}} - ({{data.satuan}})</td>
                              <td class="text-center">{{data.thn_1}}</td>
                              <td class="text-center">{{data.thn_2}}</td>
                              <td class="text-center">{{data.thn_3}}</td>
                              <td class="text-center">{{data.thn_4}}</td>
                              <td class="text-center">{{data.thn_5}}</td>
                              <td class="text-center">{{data.thn_6}}</td>

                              <td class="text-center">{{data.cap_thn_1}}</td>
                              <td class="text-center">{{data.cap_thn_2}}</td>
                              <td class="text-center">{{data.cap_thn_3}}</td>
                              <td class="text-center">{{data.cap_thn_4}}</td>
                              <td class="text-center">{{data.cap_thn_5}}</td>
                              <td class="text-center">{{data.cap_thn_6}}</td>

                              <td class="text-center" >

                                <button @click="selectData(data)" class="btn bg-light-green btn-xs waves-effect" title="Edit Data" id="edit_data" data-toggle="modal" data-target="#m_edit_data">
                                    <i class="material-icons" >create</i>
                                </button>
                              </td>
                          </tr>

                        </tbody>
                    </table>
                </div>

                <hr>
                
                <hr>

                <!-- ============================================================ MODAL ======================================================================== -->


                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-md" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-green">
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span></button>
                                    <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                                </div>
                                <form @submit.prevent="editData()">

                                <div class="modal-body">

                                <div class="row clearfix">
                                    <div class="col-md-12">
                                        <span>{{data.uraian}}</span> <br>
                                    </div>
                                </div>
                                <hr>


                                  <div class="row clearfix">
                                      <div class="col-md-4 form-control-label">
                                          <label for="kode">Capaian 2016</label>
                                      </div>
                                      <div class="col-md-8">
                                          <div class="form-group">
                                              <div class="form-line">
                                                  <input type="text" v-model="data.cap_thn_1" id="nama_urusan" class="form-control">
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                                  <div class="row clearfix">
                                      <div class="col-md-4 form-control-label">
                                          <label for="kode">Capaian 2017</label>
                                      </div>
                                      <div class="col-md-8">
                                          <div class="form-group">
                                              <div class="form-line">
                                                  <input type="text" v-model="data.cap_thn_2" id="nama_urusan" class="form-control">
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                                  <div class="row clearfix">
                                      <div class="col-md-4 form-control-label">
                                          <label for="kode">Capaian 2018</label>
                                      </div>
                                      <div class="col-md-8">
                                          <div class="form-group">
                                              <div class="form-line">
                                                  <input type="text" v-model="data.cap_thn_3" id="nama_urusan" class="form-control">
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                                  <div class="row clearfix">
                                      <div class="col-md-4 form-control-label">
                                          <label for="kode">Capaian 2019</label>
                                      </div>
                                      <div class="col-md-8">
                                          <div class="form-group">
                                              <div class="form-line">
                                                  <input type="text" v-model="data.cap_thn_4" id="nama_urusan" class="form-control">
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                                  <div class="row clearfix">
                                      <div class="col-md-4 form-control-label">
                                          <label for="kode">Capaian 2020</label>
                                      </div>
                                      <div class="col-md-8">
                                          <div class="form-group">
                                              <div class="form-line">
                                                  <input type="text" v-model="data.cap_thn_5" id="nama_urusan" class="form-control">
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                                  <div class="row clearfix">
                                      <div class="col-md-4 form-control-label">
                                          <label for="kode">Capaian 2021</label>
                                      </div>
                                      <div class="col-md-8">
                                          <div class="form-group">
                                              <div class="form-line">
                                                  <input type="text" v-model="data.cap_thn_6" id="nama_urusan" class="form-control">
                                              </div>
                                          </div>
                                      </div>
                                  </div>

                                </div>
                                <div class="modal-footer">
                                    <button type="submit" class="btn btn-success waves-effect">RUBAH</button>
                                    <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                                </form>
                            </div>
                        </div>
                    </div>
                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                <!-- ============================================================ MODAL ======================================================================== -->




        <!-- ============================================================ MULAI ======================================================================== -->
            </div>

        </div>

        </div>
      </section>



    </div>
</template>


<script>

    const ADD_URL = URL_APP+'api/v1/sakip_relisasi_iku_Daerah/';
    export default {
        name: "planning_urusan",
        data() {
            return {
                data:{
                    indikator_id: "",
                    sasaran_id: "",
                    no_indikator: "",
                    prioritas: "",
                    uraian: "",
                    satuan: "",
                    rumus_satuan: "",
                    capaian_awal: "",
                    thn_1: "",
                    thn_2: "",
                    thn_3: "",
                    thn_4: "",
                    thn_5: "",
                    thn_6: "",
                    cap_thn_1: "",
                    cap_thn_2: "",
                    cap_thn_3: "",
                    cap_thn_4: "",
                    cap_thn_5: "",
                    cap_thn_6: "",

                },
                kode_urusan: '',
                nama_urusan: '',
                urusan_pemerintahan_id: '',
                list_data: [],
                page_first : 1,
                page_last : 0,
                cari_value : ''
            };
        },

        mounted() {
            this.getData();
            // localStorage.sidemenu = 'planing';
        },

        // =============================================================== METHODS =========================================================================
        methods : {
            getData: function(){
                fetch(ADD_URL+'readData', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      data_ke : this.page_first,
                      cari_value : this.cari_value
                    })
                }).then((res) => res.json()).then((res_data) => {
                    console.log(res_data)
                  this.list_data = res_data
                })
            },
            editData: function(){
                fetch(ADD_URL+'updateData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify(this.data)
                }).then((res_data) => {
                    this.alertku("success", "Berhasil Mengubah Data!");
                    this.getData();
                });
            },

            selectData : function(data){
                this.data = {
                    indikator_id: data.indikator_id,
                    sasaran_id: data.sasaran_id,
                    no_indikator: data.no_indikator,
                    prioritas: data.prioritas,
                    uraian: data.uraian,
                    satuan: data.satuan,
                    rumus_satuan: data.rumus_satuan,
                    capaian_awal: data.capaian_awal,
                    thn_1: data.thn_1,
                    thn_2: data.thn_2,
                    thn_3: data.thn_3,
                    thn_4: data.thn_4,
                    thn_5: data.thn_5,
                    thn_6: data.thn_6,
                    cap_thn_1: data.cap_thn_1,
                    cap_thn_2: data.cap_thn_2,
                    cap_thn_3: data.cap_thn_3,
                    cap_thn_4: data.cap_thn_4,
                    cap_thn_5: data.cap_thn_5,
                    cap_thn_6: data.cap_thn_6,

                };
            },

            emptyData : function(){
                this.data = {
                    id: '',
                    kode_urusan: '',
                    nama_urusan: '',
                    user: '',
                    createdtime: ''
                };
                this.kode_urusan= '';
                this.nama_urusan= '';
                this.urusan_pemerintahan_id= '';
            },

            //PAGINASI
            alertku : function(type, title){
              this.$swal({
                type: type,
                title: title,
                showConfirmButton: false,
                timer: 800
              });
            },

            btn_prev : function(){
              if(this.page_first>1){
                this.page_first--
              }else{
                this.page_first = 1;
              }
              this.getData();
            },

            btn_next : function(){
              if(this.page_first >= this.page_last){
                this.page_first == this.page_last
              }else{
                this.page_first++;
              }
              this.getData();
            },

            cari_data : function(){
              this.getData();
            }
        },
        // =============================================================== METHODS =========================================================================

    };
</script>
